/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SBE SMS API
 * SMS API. AccessTokenGuard 보호 라우트는 Authorization: Bearer <jwt> 가 필요.
 * OpenAPI spec version: 1.0
 */

export type OriginatorStatus = typeof OriginatorStatus[keyof typeof OriginatorStatus];


export const OriginatorStatus = {
  Pending: 'Pending',
  Approved: 'Approved',
  Rejected: 'Rejected',
} as const;
